import { Stack, Typography } from '@mui/material';
import React from 'react';

import { formatSensorValue } from '../TabPanelCondition.utils';
import { tankStyle } from '../TabPanelConditionStyle';
import { GuardButton } from './GuardButton';
import { SensorStatusIndicators } from './SensorStatusIndicators';

export const TankSection = ({
  index,
  dunValue,
  dutValue,
  dpsValue,
  dntValue,
  guardOutBit,
  guardOutAll,
  guardDisabled,
  galileoskyDevice,
  transportItem,
  conditionItem,
  guardStatusTank,
  isFuelTank,
  onGuardClick,
  config,
}) => {
  const dunFormatted = formatSensorValue(dunValue, config.conditions.dun.default, config.conditions.dun.unit);

  const dutFormatted = dutValue === config.conditions.dut.default ? '-1' : Math.round(dutValue);

  const hasSensors = transportItem.fuel_availability_sensor || transportItem.drain_sensor || transportItem.ground_sensor;

  const isGuardOutDisabled = guardOutAll[1] === '1' || config.transportDeviceTypes[transportItem.device_type] !== 'galileosky';

  return (
    <Stack className='MuiPaperProgress-root' sx={(theme) => tankStyle(theme, conditionItem, index, guardStatusTank, isFuelTank)}>
      <div className='MuiPaperProgress-cover'>
        <Typography className='MuiPaperProgress-degrees' variant='caption'>
          {galileoskyDevice ? dunFormatted : '-'}
        </Typography>
      </div>

      <div className='MuiPaperProgress-determinate'>
        <Typography variant='caption'>{galileoskyDevice ? dutFormatted : ''}</Typography>
      </div>

      {!isFuelTank && hasSensors ? (
        <SensorStatusIndicators
          hasDrainSensor={!!transportItem.drain_sensor}
          hasFuelSensor={!!transportItem.fuel_availability_sensor}
          drainSensorValue={dpsValue}
          fuelSensorValue={dntValue}
          isDefaultDrain={dpsValue === config.conditions.dps.default}
          isDefaultFuel={dntValue === -1}
          hasDevice={galileoskyDevice}
        />
      ) : null}

      <div className='MuiPaperProgress-button'>
        <GuardButton
          isLocked={guardOutBit === '1'}
          disabled={isGuardOutDisabled}
          guardDisabled={guardDisabled}
          onToggle={() => onGuardClick(index + 1 + (guardOutBit === '1' ? 0 : 10))}
        />
      </div>
    </Stack>
  );
};
